import { render, staticRenderFns } from "./dal-footer.vue?vue&type=template&id=dd870ee8"
import script from "./dal-footer.vue?vue&type=script&lang=js"
export * from "./dal-footer.vue?vue&type=script&lang=js"
import style0 from "./dal-footer.vue?vue&type=style&index=0&id=dd870ee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports